import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import TYPES from '../../action-types';
import Toast from '../../../components/Toast';
import sdk from '../../../sdk';

import asyncCheckMultipleChanges from './asyncCheckMultipleChanges';
import { reloadCurrentPage } from '../../../helpers/history';

/**
 * Assign user to assets
 * @param {string} assigneeId
 * @param {string[]?} ids - assets ids
 */
const assignUser = (assigneeId, ids) => async (dispatch, getAll) => {
  const selectedItems = ids || getAll().assets.selectedItems;
  try {
    await asyncCheckMultipleChanges(selectedItems.length);
  } catch (error) {
    /** User cancelled operation */
    return;
  }
  try {
    dispatch({ type: TYPES.ASSETS.ASSIGN_USER.START });

    /** wait for response */
    await sdk.assets.assign(assigneeId, selectedItems);

    dispatch({
      type: TYPES.ASSETS.ASSIGN_USER.COMPLETE,
      payload: { assigneeId, ids },
    });
  } catch (error) {
    const errorStatus = utils.getStatusFromResponceError(error);
    const errorMessage = errorStatus === 403
      ? localization.NO_PERMISSION_TO_ACCESS
      : utils.getDataFromResponceError(error, 'msg');
    if (errorMessage) {
      Toast(errorMessage, { autoClose: false, type: 'error' });
    } else {
      Toast(localization.DETAILS.textCantUpdateAssignees(ids.length), { autoClose: false, type: 'error', onOk: reloadCurrentPage, btnOkValue: localization.HISTORY.textBtnRefresh });
    }
    Logger.error(new Error('Error assing user'), { error }, [
      'AssignUserFailed',
      (error && error.message) || 'NoMessage',
    ]);
    dispatch({ type: TYPES.ASSETS.ASSIGN_USER.FAILED, error });
  }
};

export default assignUser;
